import { getCookie, removeCookie } from "../../helpers/cookies";
import { decrypt } from "../../helpers/sessions";

export const tokenHelper = {
  setToken: (accessToken) => {
    localStorage.setItem("AccessToken", accessToken);
  },

  removeToken: (key) => {
    return localStorage.removeItem("AccessToken");
  },
  setUser: (user) => {
    let test = {
      email: "email",
      password: "password",
    };
    localStorage.setItem("user", JSON.stringify(test));
  },
  getUser: async () => {
    const session = getCookie("session");
    const payload = await decrypt(session);

    return payload?.user;
  },
  getPermissions: async () => {
    const session = getCookie("session");
    const payload = await decrypt(session);
    return payload?.permissions;
  },
  removeUser: (key) => {
    return localStorage.removeItem("user");
  },
  getToken: async () => {
    const session = getCookie("session");
    const payload = await decrypt(session);

    if (!payload?.accessToken) {
      // logout triggered only once if the token is invalid
      // if (!sessionStorage.getItem("logoutTriggered")) {
      //   sessionStorage.setItem("logoutTriggered", "true");
      //   console.log("redirecting to logout");

      setTimeout(() => {
        window.location.href = "/logout";
      }, 100);
      // }

      return null;
    }

    // Clear the flag if the token is valid again
    // sessionStorage.removeItem("logoutTriggered");

    return payload.accessToken;
  },
};
